export const QueryKey = {
	attachments: 'attachments',
	content: 'content',

	users: 'users',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	orders: 'orders',
	downloadableFiles: 'downloadable-files',
	productTypes: 'product-types',
	products: 'products',
	accessories: 'accessories',
	fabrics: 'fabrics',
	fabricCategories: 'fabric-categories',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
